import { FlexBox } from "@brg/ui";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ModalWrapper = styled(FlexBox)`
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 9999;
    height: 236px;
    padding: 16px 24px;
    background-color: ${({ theme }) => theme.projectEdit.publishModal.bg};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    ${ExploreButtonHollow}, ${ExploreButtonFilled} {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        height: 36px;
        min-height: 36px;
    }
`;

export const Title = styled.div`
    font-size: 22px;
    line-height: 28px;
    font-weight: 600;
    color: ${({ theme }) => theme.projectEdit.publishModal.title.color};
    text-align: center;
`;

export const Subtitle = styled.div`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.projectEdit.publishModal.subtitle.color};
    text-align: center;
`;import { FlexBox } from "@brg/ui";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ModalWrapper = styled(FlexBox)`
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 9999;
    height: 236px;
    padding: 16px 24px;
    background-color: ${({ theme }) => theme.projectEdit.publishModal.bg};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    ${ExploreButtonHollow}, ${ExploreButtonFilled} {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        height: 36px;
        min-height: 36px;
    }
`;

export const Title = styled.div`
    font-size: 22px;
    line-height: 28px;
    font-weight: 600;
    color: ${({ theme }) => theme.projectEdit.publishModal.title.color};
    text-align: center;
`;

export const Subtitle = styled.div`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.projectEdit.publishModal.subtitle.color};
    text-align: center;
`;